module.exports = __webpack_public_path__ + "4eb491e7412fcc678a29741fdc941eba.svg";